import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { cssTheme } from '../../../themes';
import { Text, TextVariant } from '../Text';
interface Props {
  /** Pass through className to allow styles overrides */
  className?: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether the radio is checked or not */
  checked: boolean;
  /** Whether the radio is disabled or not */
  disabled?: boolean;
  /** Whether the radio container should render full width */
  fullWidth?: boolean;
  /** Whether the input has an error */
  hasError?: boolean;
  /** Content to render in label next to the radio */
  label?: ReactNode;
  /** Name used for html input element */
  name: string;
  /** The Radio change handler. Fires when user change state of Radio */
  onChange?: (e: React.SyntheticEvent) => void;
  /** Value used for html input element */
  value?: string;
  /** Use larger touch area */
  hasTouchArea?: boolean;
  /** Label size */
  labelSize?: Extract<TextVariant, 'bodyM' | 'bodyS'>;
}
const RadioElement = /*#__PURE__*/styled('div')({
  name: "RadioElement",
  class: "rhl9mzt",
  propsAsIs: false
});
export const RadioContent = /*#__PURE__*/styled('div')({
  name: "RadioContent",
  class: "rh0hsia",
  propsAsIs: false
});
export const RadioIcon = /*#__PURE__*/styled('div')({
  name: "RadioIcon",
  class: "r1sgkzqa",
  propsAsIs: false
});
export const RadioInput = /*#__PURE__*/styled('input')({
  name: "RadioInput",
  class: "r10gspcd",
  propsAsIs: false
});
const getRadioBodyMargin = (hasTouchArea?: boolean, labelSize?: TextVariant) => {
  if (!hasTouchArea) return `0`;
  if (hasTouchArea && labelSize === 'bodyM') return `${cssTheme.layout.spacing.s300} 0`;
  if (hasTouchArea && labelSize === 'bodyS') return `${cssTheme.layout.spacing.s400} 0 0`;
  return `${cssTheme.layout.spacing.s100}`;
};
const _exp38 = /*#__PURE__*/() => ({
  hasTouchArea,
  labelSize
}) => getRadioBodyMargin(hasTouchArea, labelSize);
const _exp39 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? 'flex: 1;' : '';
export const RadioBody = /*#__PURE__*/styled('label')({
  name: "RadioBody",
  class: "r2nwkls",
  propsAsIs: false,
  vars: {
    "r2nwkls-0": [_exp38()],
    "r2nwkls-1": [_exp39()]
  }
});
const _exp51 = /*#__PURE__*/() => Text;
export const StyledText = /*#__PURE__*/styled(_exp51())({
  name: "StyledText",
  class: "s1h0fg4o",
  propsAsIs: true
});
export const Radio = ({
  checked,
  value,
  name,
  dataId,
  onChange,
  label,
  disabled,
  fullWidth = false,
  hasError = false,
  hasTouchArea = false,
  className,
  labelSize = 'bodyS'
}: Props) => <RadioElement className={className}>
    <RadioBody hasTouchArea={hasTouchArea} fullWidth={fullWidth} labelSize={labelSize}>
      <RadioInput type="radio" name={name} data-id={dataId} checked={checked} value={value} disabled={disabled} data-field-error={hasError} onChange={onChange} />
      <RadioIcon />
      {Boolean(label) && <RadioContent>
          <StyledText variant={labelSize} tag="span">
            {label}
          </StyledText>
        </RadioContent>}
    </RadioBody>
  </RadioElement>;

require("./Radio.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Radio.tsx");